import React from 'react';
import PropTypes from 'prop-types';

import { SECONDS_IN_MINUTE, SECONDS_IN_HOUR } from '@scripts/utilities/time.js';


class CountdownTimer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      seconds: props.seconds
    };

    this.timer = this.timer.bind(this);

    this.interval = undefined;
  }

  timer() {
    this.setState(this.reduceTimer, this.checkTimer);
  }

  checkTimer() {
    if (this.state.seconds < 1) {
      this.removeTimer();
    }
  }

  reduceTimer(previousState) {
    return {
      seconds: (previousState.seconds - 1)
    };
  }

  removeTimer() {
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = undefined;
    }
  }

  componentDidMount() {
    this.interval = setInterval(this.timer, 1000);
  }

  componentWillUnmount() {
    this.removeTimer();
  }

  render() {
    var total = this.state.seconds;

    var hours = Math.floor(total / SECONDS_IN_HOUR);
    var minutes = Math.floor((total % SECONDS_IN_HOUR) / SECONDS_IN_MINUTE);
    var seconds = Math.floor(total % SECONDS_IN_MINUTE);

    hours = hours.toString();
    if (hours.length < 2) {
      hours = '0' + hours;
    }
    minutes = minutes.toString();
    if (minutes.length < 2) {
      minutes = '0' + minutes;
    }
    seconds = seconds.toString();
    if (seconds.length < 2) {
      seconds = '0' + seconds;
    }

    return (
      <ul className="cs-countdown">
        <li>
          <span className="cs-countdown__number">{hours}</span>
          <span className="cs-countdown__annotation">hrs</span>
        </li>
        <li>
          <span className="cs-countdown__number">{minutes}</span>
          <span className="cs-countdown__annotation">min</span>
        </li>
        <li>
          <span className="cs-countdown__number">{seconds}</span>
          <span className="cs-countdown__annotation">sec</span>
        </li>
      </ul>
    );
  }
}


CountdownTimer.propTypes = {
  seconds: PropTypes.number
};


export default CountdownTimer;

